import React, { useCallback, useEffect, useState } from 'react';
import { Field } from 'redux-form';
import { renderFieldDisabled, renderDollarDisabled, renderNumberPercentage, renderPercentageDisabled, renderToneladasDisabled } from '../../../../../Utils/renderField/renderField';

const ShoppingLatexTable = ({ data_annual, change, step, form_values }) => {
    // Estado para controlar si ya se inicializó
    const [hasInitialized, setHasInitialized] = useState(false);

    // Resetear inicialización cuando cambien los datos principales
    useEffect(() => {
        setHasInitialized(false);
    }, [data_annual && data_annual.data_equivalent_kilos_annual]);

    const calculateWetKilos = useCallback(() => {
        if (!data_annual || !data_annual.data_equivalent_kilos_annual || !form_values || !form_values.latex_table) {
            return;
        }

        const drcRow = form_values.latex_table[2];
        if (!drcRow) {
            return;
        }

        const updates = {};
        let drcSum = 0;
        let drcCount = 0;
        
        const years = data_annual.year_list || [];

        years.forEach(year => {
            const drcValue = parseFloat(drcRow[year] || 0);
            const kilosSecos = data_annual.data_equivalent_kilos_annual[year] || 0;
            
            if (drcValue > 0 && kilosSecos > 0) {
                const wetKilos = kilosSecos / (drcValue / 100);
                updates[`latex_table[1].${year}`] = wetKilos;
                drcSum += drcValue;
                drcCount++;
            } else {
                updates[`latex_table[1].${year}`] = 0;
            }
        });

        updates['latex_table[2].total'] = drcCount > 0 ? drcSum / drcCount : 0;

        // Aplicar todas las actualizaciones de una vez
        Object.entries(updates).forEach(([field, value]) => {
            change(field, value);
        });
    }, [data_annual, form_values, change]);

    // Ejecutar cálculo cuando se cargan los datos por primera vez Y cuando cambian los valores DRC
    useEffect(() => {
        if (data_annual && data_annual.data_equivalent_kilos_annual && form_values && form_values.latex_table) {
            const drcRow = form_values.latex_table[2];
            if (drcRow) {
                const years = data_annual.year_list || [];
                // Ejecutar el cálculo siempre que haya datos válidos
                calculateWetKilos();
            }
        }
    }, [data_annual, form_values, calculateWetKilos]);

    // Si no hay datos del formulario, mostrar loading
    if (!form_values || !form_values.latex_table || !Array.isArray(form_values.latex_table)) {
        return <div>Cargando datos de la tabla...</div>;
    }

    // Si no hay datos anuales, mostrar loading
    if (!data_annual || !data_annual.year_list || data_annual.year_list.length === 0) {
        return <div>No hay datos disponibles para mostrar.</div>;
    }

    const tableData = form_values.latex_table;
    const years = data_annual.year_list;

    return (
        <div className="col-sm-12 form-group np-r p-0">
            <div className="table-responsive">
                <div className="table table-striped">
                    <table className="table mb-0 text-center">
                        <thead>
                            <tr>
                                <th className='first-column table-form-fixed-cell-left-0'></th>
                                {years.map((year, index) => (
                                    <th key={index} style={{ width: "12.5%" }} className='text-right-padded-lg'>{year}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {tableData.map((row, index) => (
                                <tr
                                    key={index}
                                    style={{
                                        ...(index === 10 || index === 11 || index === 12) && { backgroundColor: "#F0FFC7" },
                                        borderBottom: (index === 0 || index === 9 || index === 10 || index === 11) ? "1px solid #035B2F" : "none"
                                    }}
                                >
                                    <td className='text-center sin-borde-top first-column-shopping table-form-fixed-cell-left-0'>
                                        <Field
                                            name={`latex_table[${index}].name`}
                                            type="text"
                                            component={renderFieldDisabled}
                                            isTextarea={false}
                                            applyStyles={false}
                                            className="form-control"
                                            placeholder='Nuevo'
                                        />
                                    </td>
                                    {years.map((year) => (
                                        <td key={year} style={{ width: "12.5%" }}>
                                            <Field
                                                name={`latex_table[${index}].${year}`}
                                                type="text"
                                                component={
                                                    // DRC siempre es de solo lectura en anuales (visualización)
                                                    row.is_drc ? renderPercentageDisabled : 
                                                    row.is_kg ? renderToneladasDisabled : 
                                                    renderDollarDisabled
                                                }
                                                className="form-control"
                                                placeholder={row.is_drc ? '0.00 %' : '$ 0.00'}
                                                disabledStyle={index === 0 ? { fontWeight: 'bold' } : {}}
                                            />
                                        </td>
                                    ))}
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default React.memo(ShoppingLatexTable);